<template>
	<div>
		<flTrecho
			v-if="form && form.aeronave"
			:form="form.aeronave"
			:disabled="false"
			:trecho-multiplo="trechoMultiplo"
			:pouso-previsto="true"
			:somente-hora="false"
			@desbloquear-pouso="(trecho) => desbloquearPouso(trecho)"
			@trecho-alterado="clickAtualizarRoteiro()"
			@atualiza-horario="(trecho) => clickAtualizarRoteiro()"
			@remove-trecho="clickAtualizarRoteiro()"
			:mudar-cabecalho="true"
		/>

		<!-- ROTEIRO -->
		<Roteiro v-if="form && form.aeronave" :form="form" />

		<!-- MAPA -->
		<div v-if="form.aeronave.id_aeronave != 0">
			<div class="row">
				<div class="col-xs-12">
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'mapa')" />
					<button
						class="btn btn-sm btn-info"
						type="button"
						@click="clickAtualizaMapa()"
						style="margin-bottom: 10px"
					>
						<i class="fa fa-fw fa-refresh"></i
						>{{ _traducao('global', 'atualizarMapa').toUpperCase() }}
					</button>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<div style="height: 400px; width: auto" :id="'map0'"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Roteiro from './roteiro.vue'
import Cadastro from '../mixins/cadastro.js'
export default {
	mixins: [Cadastro],
	components: {
		Roteiro
	},
	props: {
		form: {
			type: Object,
			required: true
		},

		aeronaves: {
			type: Array,
			required: true
		}
	},

	mounted() {
		this.parametros()
	},

	data() {
		return {
			trechoMultiplo: false,
			disabledDatahora: false,
			disableRoteiro: false,
			flagComponente: $cliente.get('componente_trecho_solicitacao'),
			maps: []
		}
	},

	methods: {
		desbloquearPouso(trecho) {
			if (Number(this.disabledDatahora)) {
				if (
					trecho.designativo_partida?.sigla &&
					trecho.designativo_partida.sigla == trecho.designativo_destino.sigla
				) {
					trecho.disableDataPouso = false
				} else {
					trecho.disableDataPouso = true
				}
			}
		},

		parametros() {
			this._getParametro(144).then((valor) =>
				valor == '1'
					? (this.trechoMultiplo = true)
					: (this.trechoMultiplo = false)
			)

			this._getParametro(152).then((valor) =>
				valor == '1'
					? (this.disabledDatahora = true)
					: (this.disabledDatahora = false)
			)
		}
	}
}
</script>